import { asyncFetchSsoAppStatus } from 'actions/sso-app';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cn from 'classnames';

export const BuyButton = ({
  fetchSsoAppStatus,
  ssoAppState,
  productId,
  productType,
  history,
  children,
  className,
  disabled
}) => {
  const [clicked, setClicked] = useState(false);
  const isDisabled = useMemo(() => {
    return disabled || ssoAppState?.isLoading || clicked;
  }, [ssoAppState, clicked, disabled]);

  useEffect(() => {
    fetchSsoAppStatus();
  }, [fetchSsoAppStatus]);

  const handleRedirectToCheckout = useCallback(
    e => {
      e.preventDefault();

      if (isDisabled) {
        return;
      }

      setClicked(true);

      let redirectUrl = `https://voomly.com/marketplace?appId=doodly&productId=${productId}&productType=${productType}&redirectUrl=${encodeURIComponent(
        window.location.href
      )}`;

      // send to auth anyway. If user is authed then Login page will redirect to checkout
      history.push(`/login?redirect_url=${encodeURIComponent(redirectUrl)}`);
    },
    [productId, productType, isDisabled, history]
  );

  return (
    <button
      type="button"
      onClick={handleRedirectToCheckout}
      className={cn('btn btn-green', className)}
      disabled={isDisabled}
    >
      {children ?? 'Buy now'}
    </button>
  );
};

const mapStateToProps = state => {
  return {
    ssoAppState: state.ssoApp
  };
};

const mapDispatchToProps = dispatch => ({
  fetchSsoAppStatus: () => dispatch(asyncFetchSsoAppStatus())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BuyButton));
